(function() {
  // Tap-to-zoom for images in page content (trail maps, event posters).
  // Images inside a link keep their link; everything else opens full size.
  var MIN_WIDTH = 200;
  var SIZE_SUFFIX = /_(\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(?=\.[a-z0-9]+(\?|$))/i;

  function fullSizeSrc(src) {
    return src.replace(SIZE_SUFFIX, '');
  }

  function buildViewer() {
    var viewer = document.createElement('div');
    viewer.className = 'page-image-zoom';
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.setAttribute('aria-label', 'Full size image');
    viewer.hidden = true;
    viewer.innerHTML =
      '<div class="page-image-zoom__bar">' +
        '<a class="page-image-zoom__open" href="#" target="_blank" rel="noopener">Open full size</a>' +
        '<button type="button" class="page-image-zoom__close" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="page-image-zoom__scroller">' +
        '<img class="page-image-zoom__image" alt="">' +
      '</div>' +
      '<p class="page-image-zoom__hint">Tap the image to zoom in</p>';
    document.body.appendChild(viewer);
    return viewer;
  }

  document.addEventListener('DOMContentLoaded', function() {
    var containers = document.querySelectorAll('[data-page-image-zoom]');
    if (!containers.length) return;

    var viewer = null;
    var lastFocus = null;

    function close() {
      viewer.hidden = true;
      viewer.classList.remove('page-image-zoom--zoomed');
      document.documentElement.classList.remove('page-image-zoom-open');
      if (lastFocus) lastFocus.focus();
    }

    function open(img) {
      if (!viewer) {
        viewer = buildViewer();
        viewer.querySelector('.page-image-zoom__close').addEventListener('click', close);
        viewer.querySelector('.page-image-zoom__image').addEventListener('click', toggleZoom);
        document.addEventListener('keydown', function(event) {
          if (event.key === 'Escape' && !viewer.hidden) close();
        });
      }

      var src = fullSizeSrc(img.currentSrc || img.src);
      var image = viewer.querySelector('.page-image-zoom__image');
      image.src = src;
      image.alt = img.alt || '';
      viewer.querySelector('.page-image-zoom__open').href = src;

      lastFocus = img;
      viewer.hidden = false;
      document.documentElement.classList.add('page-image-zoom-open');
      viewer.querySelector('.page-image-zoom__close').focus();
    }

    // Toggle between fit-to-screen and actual size, keeping the tapped spot in view
    function toggleZoom(event) {
      var image = event.currentTarget;
      var scroller = viewer.querySelector('.page-image-zoom__scroller');
      var rect = image.getBoundingClientRect();
      var x = (event.clientX - rect.left) / rect.width;
      var y = (event.clientY - rect.top) / rect.height;

      viewer.classList.toggle('page-image-zoom--zoomed');

      if (viewer.classList.contains('page-image-zoom--zoomed')) {
        scroller.scrollLeft = image.offsetWidth * x - scroller.clientWidth / 2;
        scroller.scrollTop = image.offsetHeight * y - scroller.clientHeight / 2;
      }
    }

    Array.prototype.forEach.call(containers, function(container) {
      Array.prototype.forEach.call(container.querySelectorAll('img'), function(img) {
        if (img.closest('a')) return;

        function enable() {
          if (img.offsetWidth < MIN_WIDTH) return;
          img.classList.add('page-image-zoom-trigger');
          img.setAttribute('role', 'button');
          img.setAttribute('tabindex', '0');
          img.setAttribute('aria-label', (img.alt ? img.alt + ' - ' : '') + 'view full size');
          img.addEventListener('click', function() { open(img); });
          img.addEventListener('keydown', function(event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              open(img);
            }
          });
        }

        if (img.complete) {
          enable();
        } else {
          img.addEventListener('load', enable, { once: true });
        }
      });
    });
  });
})();
